export function loopingIndex(value, total) {
  const min = 0
  const max = total - 1

  if (value > max) {
    return value % total
  }
  if ((value < min) && (max >= 0)) {
    return max + ((value + 1) % total)
  }
  return value
}
